import React from "react";

import { Stack } from "@mui/system";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./PipelineSummary.module.css";

interface PipelineSummaryProps {
  advisorCount: number;
}

const PipelineSummary: React.FC<PipelineSummaryProps> = ({ advisorCount }) => {
  return (
    <Stack
      className={styles.container}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Text variant="title2">Pipeline Summary</Text>
      <Text variant="body" color="textSubtle">
        {advisorCount} advisors in the pipeline
      </Text>
    </Stack>
  );
};

export default PipelineSummary;
